<template>
	<div class="wrapper-anchorContent">
		<a
			class="anchor-text"
			href="javascript:"
		>
			<div class="image-wrapper">
				<NuxtImg
					v-if="iconImage"
					class="icon-image"
					:alt="iconImage.alt"
					:src="iconImage.md"
				/>
			</div>

			{{ lightbox.anchorContent }}
		</a>
	</div>
</template>

<script>
import ResponsiveImageViewModel from "~/helpers/ViewModels/ResponsiveImageViewModel.js";

export default defineNuxtComponent({
	name: "LegacyLightboxTrigger",
	props: {
		anchorContent: {
			type: String,
		},
		lightbox: {
			type: Object,
		},
		image: {
			type: Object,
		},
	},

	computed: {
		iconImage() {
			return this.lightbox.image && ResponsiveImageViewModel(this.lightbox.image);
		},
	},
});
</script>

<style scoped lang="scss">
.wrapper-anchorContent {
	display: grid;
	width: fit-content;
	align-content: center;
	margin: 8px auto;
	text-align: center;
	padding: 0 5px 20px;

	.anchor-text {
		color: $color-cta-default;

		@include font-text-m;

		&.yng {
			color: $color-neutrals-black;
		}
	}

	.image-wrapper {
		display: flex;
		justify-content: center;

		.icon-image {
			width: 100px;
			height: 100px;
			margin-bottom: $spacing-s;
			background-size: contain;
			background-repeat: no-repeat;

			&:hover {
				cursor: pointer;
			}
		}
	}
}
</style>
